import ICU from 'i18next-icu';
import { i18n } from 'next-i18next';
import { i18nConfig } from '@flex-packages/i18n-base';
import { decideLocale } from './decideLocale.mjs';

const getNextI18NextConfig = (resources) => {
  return {
    i18n: i18nConfig.i18n,
    localePath: null,
    defaultNS: "translation",
    // https://github.com/isaachinman/next-i18next#unserialisable-configs
    serializeConfig: false,
    fallbackNS: "translation",
    use: [ICU],
    resources
  };
};
const getTranslationsProps = (serverSideTranslations, resource) => {
  return async (context) => {
    try {
      if (process.env.NODE_ENV === "development" && i18n) {
        await i18n.reloadResources();
      }
      const config = getNextI18NextConfig(resource);
      return {
        props: await serverSideTranslations(
          await decideLocale(context),
          void 0,
          config
        )
      };
    } catch (error) {
      console.error(error);
      throw new Error(
        `[getNextI18NextConfig]\uC5D0\uC11C \uCC38\uC870 \uAC00\uB2A5\uD55C locale\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.`
      );
    }
  };
};

export { getTranslationsProps as default, getNextI18NextConfig };
//# sourceMappingURL=getTranslationsProps.mjs.map
